// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yrVD","icon":"styles_icon__HurBk"};